import { Button } from "primereact/button"
import { useLocation } from "react-router-dom";

const Footer = () => {

    const { pathname } = useLocation();

    const mapName = (pathname === "/healthcare-providers" || pathname === "/request-demo" || pathname === "/about-us")
        ? "DOWNLOAD_SECTION"
        : "SOCIAL_MEDIA_SECTION";

    const renderButtonsMapping = {
        DOWNLOAD_SECTION: (
            <>
                <div className="flex flex-column gap-5 w-full">
                    <span className="text-xl text-white" style={{ fontWeight: 700 }}>Download Now</span>
                    <div className="flex justify-content-center md:justify-content-between flex-wrap gap-5 align-items-center">
                        <div className="flex flex-wrap justify-content-center xl:justify-content-start gap-4" >
                            <Button
                                style={{
                                    color: "white",
                                    backgroundColor: "#E3506B",
                                    borderRadius: "10px",
                                    height: "3.5rem",
                                    width: "11rem",
                                    display: "flex",
                                    justifyContent: "center"
                                }} >
                                <div className="flex align-items-center">
                                    <img src="/AppStoreLogo.svg" />
                                </div>
                            </Button  >

                            <Button
                                style={{
                                    color: "white",
                                    backgroundColor: "#E3506B",
                                    borderRadius: "10px",
                                    height: "3.5rem",
                                    width: "11rem",
                                    display: "flex",
                                    justifyContent: "center"
                                }}  >
                                <div className="flex  align-items-center">
                                    <img src="/GoogleLogo.svg" />
                                </div>
                            </Button>
                        </div>
                        <div className="flex flex-wrap gap-4 justify-content-center align-items-center">
                            <Button
                                style={{
                                    color: "white",
                                    border: "1px solid #FFFFFF",
                                    backgroundColor: "transparent",
                                    borderRadius: "10px",
                                    height: "3.5rem",
                                    width: "3.5rem",
                                    display: "flex",
                                    justifyContent: "center"
                                }} >
                                <div className="flex align-items-center">
                                    <img src="/LinkedinIcon.svg" />
                                </div>
                            </Button>
                            <Button
                                style={{
                                    color: "white",
                                    border: "1px solid #FFFFFF",
                                    backgroundColor: "transparent",
                                    borderRadius: "10px",
                                    height: "3.5rem",
                                    width: "3.5rem",
                                    display: "flex",

                                    justifyContent: "center"
                                }} >
                                <div className="flex align-items-center">
                                    <img src="/InstagramIcon.svg" />
                                </div>
                            </Button  >
                            <Button
                                style={{
                                    color: "white",
                                    border: "1px solid #FFFFFF",
                                    backgroundColor: "transparent",
                                    borderRadius: "10px",
                                    height: "3.5rem",
                                    width: "3.5rem",
                                    display: "flex",

                                    justifyContent: "center"
                                }} >
                                <div className="flex align-items-center">
                                    <img src="/YoutubeIcon.svg" />
                                </div>
                            </Button>
                            {pathname !== "/request-demo" && (
                                <Button
                                    className="font-bold"
                                    style={{
                                        color: "white",
                                        backgroundColor: "#E3506B",
                                        borderRadius: "10px",
                                        height: "3.5rem",
                                    }}>
                                        <div className="flex gap-2 align-items-center">
                                            <img src="/Mail.png" />
                                            <span className="text-xl" style={{ fontWeight: 700 }}>info@mobithera.com</span>
                                        </div>
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </>
        ),
        SOCIAL_MEDIA_SECTION: (
            <div className="flex justify-content-center md:justify-content-between flex-wrap gap-5 align-items-center">
                <div className="flex gap-4" >
                    <Button
                        style={{
                            color: "white",
                            border: "1px solid #FFFFFF",
                            backgroundColor: "transparent",
                            borderRadius: "10px",
                            height: "3.5rem",
                            width: "3.5rem",
                            display: "flex",
                            justifyContent: "center"
                        }} >
                        <div className="flex align-items-center">
                            <img src="/LinkedinIcon.svg" />
                        </div>
                    </Button>
                    <Button
                        style={{
                            color: "white",
                            border: "1px solid #FFFFFF",
                            backgroundColor: "transparent",
                            borderRadius: "10px",
                            height: "3.5rem",
                            width: "3.5rem",
                            display: "flex",

                            justifyContent: "center"
                        }} >
                        <div className="flex align-items-center">
                            <img src="/InstagramIcon.svg" />
                        </div>
                    </Button>
                    <Button
                        style={{
                            color: "white",
                            border: "1px solid #FFFFFF",
                            backgroundColor: "transparent",
                            borderRadius: "10px",
                            height: "3.5rem",
                            width: "3.5rem",
                            display: "flex",

                            justifyContent: "center"
                        }} >
                        <div className="flex align-items-center">
                            <img src="/YoutubeIcon.svg" />
                        </div>
                    </Button  >
                </div>
                <Button
                    className="font-bold"
                    style={{
                        color: "white",
                        backgroundColor: "#E3506B",
                        borderRadius: "10px",
                        height: "3.5rem",
                    }}>
                        <div className="flex gap-2 align-items-center">
                            <img src="/Mail.png" />
                            <span className="text-lg" style={{ fontWeight: 700 }}>info@mobithera.com</span>
                        </div>
                </Button>
            </div>
        )
    }

    return (
        <>
            <div className="flex flex-column gap-8 py-8 px-4 md:px-8" style={{
                width: "100%",
                minHeight: "50vh",
                backgroundColor: "#2D3967",
            }}
            >
                <div className="flex flex-wrap gap-8 justify-content-between align-items-start">
                    <div className="flex flex-column gap-4 align-items-start">
                        <div className="flex align-items-center gap-1">
                            <img 
                                src="/Logo.svg" 
                                className="cursor-pointer" 
                                height={40} 
                                alt="Mobithera Logo" 
                            />
                            <span style={{ fontSize: "1rem", color: "#FFFFFF", marginTop: "-0.5rem" }}>™</span>
                        </div>
                        <p className="m-0 text-lg md:w-30rem flex-grow-1" style={{ color: "#FFFFFF" }} >
                            Unlock the power of AI with personalized
                            physiotherapy programs tailored to your
                            needs.
                        </p>
                    </div>

                    <div className="flex flex-column gap-4 align-items-start">
                        <p className="m-0 text-xl font-bold" style={{ color: "#FFFFFF" }} >For Individuals</p>
                        <div className="flex flex-column gap-2">
                            <p className="m-0 text-lg" style={{ color: "#FFFFFF" }} >Personalized Programs</p>
                            <p className="m-0 text-lg" style={{ color: "#FFFFFF" }} >Real-Time Feedback</p>
                            <p className="m-0 text-lg" style={{ color: "#FFFFFF" }} >Daily Progress Tracking</p>
                            <p className="m-0 text-lg" style={{ color: "#FFFFFF" }} >Pain & Recovery Support</p>
                        </div>
                    </div>

                    <div className="flex flex-column gap-4 align-items-start">
                        <p className="m-0 text-xl font-bold" style={{ color: "#FFFFFF" }} >For Healthcare Providers</p>
                        <div className="flex flex-column gap-2">
                            <p className="m-0 text-lg" style={{ color: "#FFFFFF" }} >Clinic Dashboard</p>
                            <p className="m-0 text-lg" style={{ color: "#FFFFFF" }} >Remote Patient Monitoring</p>
                            <p className="m-0 text-lg" style={{ color: "#FFFFFF" }} >Outcome Analytics</p>
                            <p className="m-0 text-lg" style={{ color: "#FFFFFF" }} >RTM Billing Integration</p>
                        </div>
                    </div>

                    <div className="flex flex-column gap-4 align-items-start">
                        <p className="m-0 text-xl font-bold" style={{ color: "#FFFFFF" }} >Quick Access</p>
                        <div className="flex flex-column gap-2">
                            <p className="m-0 text-lg" style={{ color: "#FFFFFF" }} >About Us</p>
                            <p className="m-0 text-lg" style={{ color: "#FFFFFF" }} >FaQ</p>
                            <p className="m-0 text-lg" style={{ color: "#FFFFFF" }} >Terms of Use</p>
                        </div>
                    </div>
                </div>
                {renderButtonsMapping[mapName]}
            </div>
            <div className="w-full flex justify-content-center align-items-center"
                style={{
                    width: "100%",
                    minHeight: "7vh",
                    backgroundColor: "#29345E",
                }}
            >
                <p className="text-base" style={{ color: "#727A99" }}>© {new Date().getFullYear()} <span className="font-bold" style={{ color: "#FFFFFF" }}>Mobithera Technology.</span> All Rights Reserved.</p>
            </div>
        </>
    )
}

export default Footer;